module.exports = __webpack_public_path__ + "img/construccion.e3bc0712.jpg";